import kyc from './kyc';
import onboarding from './onboarding';

const MoReducers = { kyc, onboarding };

export default MoReducers;
